import * as actionTypes from './ActionTypes';

export const submit_unlocked_achievement = (submit_data) => {
  return {
    type: actionTypes.UNLOCK_ACHIEVEMENT,
    data: submit_data,
  };
};

export const achievement_unlocked = (achievement_key, value) => ({
  type: actionTypes.ACHIEVEMENT_UNLOCKED,
  achievement_key,
  value,
});

export const fetchAchievementDetails = (params, callback = () => {
}) => {
  return {
    type: actionTypes.FETCH_ACHIEVEMENT_DETAILS,
    params: params,
    callback,
  };
};

export const updateAchievementDetails = (data) => {
  return {
    type: actionTypes.UPDATE_ACHIEVEMENT_DETAILS,
    data: data,
  };
};
